import React, { Component } from "react"
import FormField from "../FormField"
import { InputNumber } from "formik-antd"

export default class AvgComments extends Component {
  render() {
    return (
      <FormField name={this.props.name || "metadata.avg_comments"} label="Avg. Comments">
        <InputNumber
          data-cy="account-avg-comments"
          style={{ width: "100%" }}
          size="large"
          placeholder="1000"
        />
      </FormField>
    )
  }
}
